<template>
  <div class="text-sm">
    <p>Copyright © 2007 - {{ currentYear }} expondo</p>
  </div>
</template>

<script lang="ts">

export default defineComponent({
  setup () {

    const currentYear = new Date().getFullYear();

    return { currentYear };
  
  },
});

</script>
